<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { defineProps, inject, ref, defineModel, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  matrix: DestinyMatrix | undefined;
  hasPremiumAccess: boolean;
}>();
const isOpen = defineModel<boolean>({ default: false });
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(
      DestinyMatrixKeysEnum.EXCESS_WEIGHT_IN_MATRIX
    );
  }
}
</script>

<template>
  <AccordionComponent
    type="white"
    @opened="getData"
    v-model="isOpen"
    :isBlocked="!hasPremiumAccess"
  >
    <template #title>
      {{
        t("calculators.destiny-matrix.accordions.excess-weight-in-matrix.title")
      }}
    </template>
    <template #faq-content>
      <div v-if="description" class="flex flex-col gap-2">
        <div class="whitespace-pre-line font-bold text-xl">
          {{
            t(
              "calculators.destiny-matrix.accordions.excess-weight-in-matrix.desc-title"
            )
          }}
        </div>
        <div class="whitespace-pre-line">
          {{
            t(
              "calculators.destiny-matrix.accordions.excess-weight-in-matrix.desc"
            )
          }}
        </div>
        <p class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.excess-weight-in-matrix.value-title"
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description[matrix.r1.l] }}
        </div>
        <div class="whitespace-pre-line">
          {{ description[matrix.r1.t] }}
        </div>
        <div class="whitespace-pre-line">
          {{ description[matrix.r1.r] }}
        </div>
        <div class="whitespace-pre-line">
          {{ description[matrix.r1.b] }}
        </div>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.destiny-matrix.accordions.collapse") }}
    </template>
  </AccordionComponent>
</template>
